const riot = require('riot');

riot.tag2('module-receive-paypay', '<div class="pt24 px24" if="{error?.status === 409}"> <div class="ts-hl text-navy mb24">特典を付与できませんでした</div> <div class="ts-ps text-gray_80">このPayPayアカウントは、すでに本キャンペーンの特典を受け取っています。<br>受け取りはお一人様一回までとなります。<br><br>受取済みの特典はPayPayアプリ下部にある「ウォレット」からご確認下さい。</div> </div> <div if="{error?.status !== 409}"> <div class="bg-grad_light_blue w-full h180 pt24"> <div class="text-center ts-hl text-white">ありがとうございました</div> </div> <div class="px24 mtn105"> <div class="w-full pb20 px20 pt36 rounded-8 elevation-default-mid text-center bg-white mb24"> <div class="f fh mb20"><img class="block w75per object-fit-contain" src="/images/paypay/logo.jpg"></div> <div class="ts-hs text-gray_80 mb4">PayPayポイント</div> <div class="f fc fb"><span class="fs40 text-gray_80 mr8">{opts.event.amount.toLocaleString(\'ja-JP\')}</span><span class="ts-hs text-gray_60">円分</span></div> </div> <div> <p class="ts-ps text-gray_80" if="{!error}">連携が完了しました。特典が付与されます。<br>PayPayポイントは出金、譲渡不可です。PayPay／PayPayカード公式ストアでも利用可能です。</p> <div class="ts-ps text-gray_80" if="{error}"> <p>エラーが発生しました。<br>status: {error.status}<br>{error.message}</p> <div if="{hash}"> <p class="mt12">時間をおいて、以下のページから再度連携をお試しください</p><a class="button primary mt8" href="/gift?hash={hash}">連携ページ</a> </div> </div> </div> </div> </div>', '', '', function(opts) {
    this.preload = async ({ req }) => {
      const hash = req.query.hash;
      const responseToken = req.query.responseToken;

      if (!responseToken) {
        const error = { status: 404, message: '認証情報の取得に失敗しました' };
        return {
          error,
          hash,
        };
      }

      let error = null;
      try {
        await app.api.child('paypay/publish').post({
          authorization_response_token: responseToken,
        });
      } catch(e) {
        error = e;
        console.error(e);
      }

      return {
        error,
        hash,
      };
    };
});